import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the ReportHeaderV2 state domain
 */

const selectReportHeaderV2Domain = (state) =>
  state.get("reportHeaderV2", initialState)

/**
 * Other specific selectors
 */

export const makeSelectLoadingMeditions = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("loadingMeditions")
  )

export const makeSelectMeditions = () =>
  createSelector(selectReportHeaderV2Domain, (state) => state.get("meditions"))

export const makeSelectIsLoadingSurveyTypes = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("isLoadingSurveyTypes")
  )

export const makeSelectSurveyTypes = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("surveyTypes")
  )

export const makeSelectAllMeditions = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("all_meditions")
  )

export const makeSelectAmbassadorCount = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("ambassador_count")
  )

export const makeSelectIsEmptyMeditions = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("isEmptyMeditions")
  )

export const makeSelectOfficializeLoading = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("officializeLoading")
  )

export const makeSelectOfficialize = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("officialize")
  )

export const makeSelectCurrentMedition = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("current_medition")
  )

export const makeSelectMeditionAvailableActions = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("available_actions")
  )

export const makeSelectMeasure = () =>
  createSelector(selectReportHeaderV2Domain, (state) =>
    state.get("measure")
  )
/**
 * Default selector used by ReportHeaderV2
 */

const makeSelectReportHeaderV2 = () =>
  createSelector(selectReportHeaderV2Domain, (substate) => substate.toJS())

export default makeSelectReportHeaderV2
export { selectReportHeaderV2Domain }
